// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import 'react-calendar/dist/Calendar.css';
// import * as Constants from '../../Constant/constant';
// import { useAuth } from '../../Constant/Auth';
// import { useNavigate, useLocation } from 'react-router-dom';
// import './IssuedBookList.css';

// const IssuedBookList = () => {
//   const [libraries, setLibraries] = useState([]);
//   const [issueDate, setIssueDate] = useState('');
//   const [returnDate, setReturnDate] = useState('');
//   const [bookCopies, setBookCopies] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState('');
//   const [books, setBooks] = useState([]);
//   const [modalOpen, setModalOpen] = useState(false);
//   const [selectedIssueId, setSelectedIssueId] = useState(null);
//   const [approvedIssues, setApprovedIssues] = useState(new Set());
//   const [currentPage, setCurrentPage] = useState(1);
//   const entriesPerPage = 10;

//   const location = useLocation();
//   const navigate = useNavigate();
//   const { user } = useAuth();

//   const issueDateParam = location.search.split('issueDate=')[1]?.split('&')[0];
//   const returnDateParam = location.search.split('returnDate=')[1]?.split('&')[0];

//   useEffect(() => {
//     fetchBooks();
//     fetchLibraries();
//     fetchBookList();
//   }, []);

//   useEffect(() => {
//     if (issueDateParam && returnDateParam) {
//       setIssueDate(issueDateParam);
//       setReturnDate(returnDateParam);
//     }
//   }, [issueDateParam, returnDateParam]);

//   const fetchLibraries = async () => {
//     try {
//       const response = await axios.get(Constants.API_PATH + `/add_new_library_data`);
//       setLibraries(response.data);
//     } catch (error) {
//       console.error('Error fetching libraries:', error);
//       setError('Failed to fetch libraries.');
//     }
//   };

//   const fetchBooks = async () => {
//     setLoading(true);
//     setError('');
//     try {
//       const response = await axios.get(Constants.API_PATH + `/issued-books`);
//       console.log("All Issued Books data received:", response.data);
//       setBookCopies(response.data);
//     } catch (error) {
//       console.error('Error fetching issued books:', error);
//       setError('Failed to fetch issued books.');
//       setBookCopies([]);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const fetchBookList = async () => {
//     try {
//       const response = await axios.get(Constants.API_PATH + `/book_list`);
//       setBooks(response.data);
//     } catch (error) {
//       console.error('Error fetching book list:', error);
//     }
//   };

//   const getBookName = (bookId) => {
//     const found = books.find((b) => b.id === bookId);
//     return found ? found.book_name : 'Unknown Book';
//   };

//   const handleApprove = (issueId) => {
//     setSelectedIssueId(issueId);
//     setModalOpen(true);
//   };

//   const handleConfirmApproval = async () => {
//     try {
//       const response = await axios.put(`${Constants.API_PATH}/update-book-status/${selectedIssueId}`, {
//         status: 0 // Issued
//       });

//       if (response.status === 200 ) {
//         alert('Book issue approved successfully');
//         setApprovedIssues(prev => new Set(prev.add(selectedIssueId)));
//         setBookCopies(prev =>
//           prev.map(book =>
//             book.issue_id === selectedIssueId ? { ...book, status: 0 } : book
//           )
//         );
//       } else {
//         alert('Failed to approve book issue');
//       }
//     } catch (error) {
//       console.error('Error approving book issue:', error);
//       alert('Error approving book issue.');
//     } finally {
//       setModalOpen(false);
//     }
//   };

//   const handleReturnBook = async (issueId) => {
//     try {
//       const response = await axios.put(`${Constants.API_PATH}/update-book-status/${issueId}`, {
//         status: 2 // Returned
//       });

//       if (response.status === 200) {
//         alert('Book returned successfully');
//         fetchBooks();
//         setApprovedIssues(prev => {
//           const newSet = new Set(prev);
//           newSet.delete(issueId);
//           return newSet;
//         });
//       } else {
//         alert('Failed to return book');
//       }
//     } catch (error) {
//       console.error('Error returning book:', error);
//       alert('Error returning book.');
//     }
//   };

//   const getStatusText = (statusCode) => {
//     switch (statusCode) {
//       case 0: return 'Issued';
//       case 1: return 'Pending';
//       case 2: return 'Returned';
//       case 3: return 'Rejected';
//       case 4: return 'Available';
//       default: return 'Unknown';
//     }
//   };

//   // Pagination logic
//   const indexOfLastEntry = currentPage * entriesPerPage;
//   const indexOfFirstEntry = indexOfLastEntry - entriesPerPage;
//   const currentBookCopies = bookCopies.slice(indexOfFirstEntry, indexOfLastEntry);

//   return (
//     <div className="parent-issue-book-container containernew">
//       <h2>All Issued Books</h2>

//       <div className="table-section">
//         {loading ? (
//           <p>Loading...</p>
//         ) : error ? (
//           <p style={{ color: 'red' }}>{error}</p>
//         ) : bookCopies.length === 0 ? (
//           <p>No issued books found.</p>
//         ) : (
//           <>
//             <table className='custom-table'>
//               <thead>
//                 <tr>
//                   <th>Sr No</th>
//                   <th>Book Name</th>
//                   <th>Issue Date</th>
//                   <th>Due Date</th>
//                   <th>Return Date</th>
//                   <th>Status</th>
//                   <th>Approval</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {currentBookCopies.map((book, index) => (
//                   <tr key={index}>
//                     <td>{indexOfFirstEntry + index + 1}</td>
//                     <td>{book.book_name}</td>
//                     <td>{book.issue_date}</td>
//                     <td>{book.due_date}</td>
//                     <td>{book.return_date}</td>
//                     <td>{getStatusText(book.status)}</td>
//                     <td>
//                       {book.status === 1 ? (
//                         <button
//                           className="btn btn-success btn-sm action-button"
//                           onClick={() => handleApprove(book.issue_id)}
//                         >
//                           Approve
//                         </button>
//                       ) : (
//                         book.status === 0 && (
//                           <button
//                             className="btn btn-danger btn-sm action-button"
//                             onClick={() => handleReturnBook(book.issue_id)}
//                           >
//                             Return
//                           </button>
//                         )
//                       )}
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>

//             {/* Pagination Controls */}
//             <div className="pagination-controls">
//               <button
//                 className="pagination-button"
//                 onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
//                 disabled={currentPage === 1}
//               >
//                 Previous
//               </button>

//               <span className="pagination-info">
//                 Page {currentPage} of {Math.ceil(bookCopies.length / entriesPerPage)}
//               </span>

//               <button
//                 className="pagination-button"
//                 onClick={() => setCurrentPage(prev => Math.min(prev + 1, Math.ceil(bookCopies.length / entriesPerPage)))}
//                 disabled={currentPage === Math.ceil(bookCopies.length / entriesPerPage)}
//               >
//                 Next
//               </button>
//             </div>
//           </>
//         )}
//       </div>

//       {modalOpen && (
//         <div className="modal-overlay">
//           <div className="modal-content">
//             <button className="modal-close-button" onClick={() => setModalOpen(false)}>×</button>
//             <h2>Confirm Approval</h2>
//             <p>Are you sure you want to approve this book issue?</p>
//             <button type="button" onClick={handleConfirmApproval}>
//               Confirm
//             </button>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default IssuedBookList;





// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import 'react-calendar/dist/Calendar.css';
// import * as Constants from '../../Constant/constant';
// import { useAuth } from '../../Constant/Auth';
// import { useNavigate, useLocation } from 'react-router-dom';
// import './IssuedBookList.css';

// const IssuedBookList = () => {
//   const [libraries, setLibraries] = useState([]);
//   const [issueDate, setIssueDate] = useState('');
//   const [returnDate, setReturnDate] = useState('');
//   const [bookCopies, setBookCopies] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState('');
//   const [books, setBooks] = useState([]);
//   const [modalOpen, setModalOpen] = useState(false);
//   const [selectedIssueId, setSelectedIssueId] = useState(null);
//   const [approvedIssues, setApprovedIssues] = useState(new Set());
//   const [currentPage, setCurrentPage] = useState(1);
//   //const [searchText, setSearchText] = useState('');
//   const [filteredData, setFilteredData] = useState([]);
//   const [data, setData] = useState([]);
//   const [searchText, setSearchText] = useState('');
// const [issuedBooks, setIssuedBooks] = useState([]);


//   const entriesPerPage = 10;
//     const itemsPerPage = 10;

//   const location = useLocation();
//   const navigate = useNavigate();
//   const { user } = useAuth();
//   const [filters, setFilters] = useState({
//   library: '',
//   book: '',
//   user: '',
//   email: '',
//   issueDate: '',
//   dueDate: '',
//   returnDate: '',
//   status: ''
// });
// const [showFilters, setShowFilters] = useState(false);




//   const issueDateParam = location.search.split('issueDate=')[1]?.split('&')[0];
//   const returnDateParam = location.search.split('returnDate=')[1]?.split('&')[0];
// filteredData = data.filter(item => 
//   item.name && searchText && item.name.toLowerCase().includes(searchText.toLowerCase())
// );



//   useEffect(() => {
//     fetchBooks();
//     fetchLibraries();
//     fetchBookList();
//   }, []);

//   useEffect(() => {
//     if (issueDateParam && returnDateParam) {
//       setIssueDate(issueDateParam);
//       setReturnDate(returnDateParam);
//     }
//   }, [issueDateParam, returnDateParam]);

//   const fetchLibraries = async () => {
//     try {
//       const response = await axios.get(Constants.API_PATH + `/add_new_library_data`);
//       setLibraries(response.data);
//     } catch (error) {
//       console.error('Error fetching libraries:', error);
//       setError('Failed to fetch libraries.');
//     }
//   };

//   const fetchBooks = async () => {
//     setLoading(true);
//     setError('');
//     try {
//       const response = await axios.get(Constants.API_PATH + `/issued-books`);
//       console.log("All Issued Books data received:", response.data);
//       setBookCopies(response.data);
//     } catch (error) {
//       console.error('Error fetching issued books:', error);
//       setError('Failed to fetch issued books.');
//       setBookCopies([]);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const fetchBookList = async () => {
//     try {
//       const response = await axios.get(Constants.API_PATH + `/book_list`);
//       setBooks(response.data);
//     } catch (error) {
//       console.error('Error fetching book list:', error);
//     }
//   };

//   const getBookName = (bookId) => {
//     const found = books.find((b) => b.id === bookId);
//     return found ? found.book_name : 'Unknown Book';
//   };

//   const handleApprove = (issueId) => {
//     setSelectedIssueId(issueId);
//     setModalOpen(true);
//   };

//   const handleConfirmApproval = async () => {
//     try {
//       const response = await axios.put(`${Constants.API_PATH}/update-book-status/${selectedIssueId}`, {
//         status: 0 // Issued
//       });

//       if (response.status === 200) {
//         alert('Book issue approved successfully');
//         setApprovedIssues(prev => new Set(prev.add(selectedIssueId)));
//         setBookCopies(prev =>
//           prev.map(book =>
//             book.issue_id === selectedIssueId ? { ...book, status: 0 } : book
//           )
//         );
//       } else {
//         alert('Failed to approve book issue');
//       }
//     } catch (error) {
//       console.error('Error approving book issue:', error);
//       alert('Error approving book issue.');
//     } finally {
//       setModalOpen(false);
//     }
//   };

//   const handleReject = async (issueId) => {
//     const confirmReject = window.confirm("Are you sure you want to reject this book issue?");
//     if (!confirmReject) return;

//     try {
//       const response = await axios.put(`${Constants.API_PATH}/update-book-status/${issueId}`, {
//         status: 3 // Rejected
//       });

//       if (response.status === 200) {
//         alert('Book issue rejected successfully');
//         setBookCopies(prev =>
//           prev.map(book =>
//             book.issue_id === issueId ? { ...book, status: 3 } : book
//           )
//         );
//       } else {
//         alert('Failed to reject book issue');
//       }
//     } catch (error) {
//       console.error('Error rejecting book issue:', error);
//       alert('Error rejecting book issue.');
//     }
//   };

//   const handleReturnBook = async (issueId) => {
//     try {
//       const response = await axios.put(`${Constants.API_PATH}/update-book-status/${issueId}`, {
//         status: 2 // Returned
//       });

//       if (response.status === 200) {
//         alert('Book returned successfully');
//         fetchBooks();
//         setApprovedIssues(prev => {
//           const newSet = new Set(prev);
//           newSet.delete(issueId);
//           return newSet;
//         });
//       } else {
//         alert('Failed to return book');
//       }
//     } catch (error) {
//       console.error('Error returning book:', error);
//       alert('Error returning book.');
//     }
//   };

//   const getStatusText = (statusCode) => {
//     switch (statusCode) {
//       case 0: return 'Issued';
//       case 1: return 'Pending';
//       case 2: return 'Returned';
//       case 3: return 'Rejected';
//       case 4: return 'Available';
//       default: return 'Unknown';
//     }
//   };

//   // Pagination logic
//   const indexOfLastEntry = currentPage * entriesPerPage;
//   const indexOfFirstEntry = indexOfLastEntry - entriesPerPage;
//   const currentBookCopies = bookCopies.slice(indexOfFirstEntry, indexOfLastEntry);

//   const getLibraryName = (id) => {
//   const lib = libraries.find(library => library.id === id);
//   return lib ? lib.library_name : 'Unknown Library';
// };



//  const filteredBookCopies = bookCopies.filter((book) => {
//     return (
//       book.student_name?.toLowerCase().includes(filters.student_name.toLowerCase()) &&
//       book.email?.toLowerCase().includes(filters.email.toLowerCase()) &&
//       book.book_name?.toLowerCase().includes(filters.book_name.toLowerCase()) &&
//       getStatusText(book.status).toLowerCase().includes(filters.status.toLowerCase())
//     );
//   });

//   const indexOfLastItem = currentPage * itemsPerPage;
//   const indexOfFirstItem = indexOfLastItem - itemsPerPage;
//   const currentItems = filteredBookCopies.slice(indexOfFirstItem, indexOfLastItem);
//   const totalPages = Math.ceil(filteredBookCopies.length / itemsPerPage);
//   return (
//     <div className="parent-issue-book-container containernew">
//       <h2>All Issued Books</h2>

//       <div className="table-section">
//         {loading ? (
//           <p>Loading...</p>
//         ) : error ? (
//           <p style={{ color: 'red' }}>{error}</p>
//         ) : bookCopies.length === 0 ? (
//           <p>No issued books found.</p>
//         ) : (
//           <>
//             <table className='custom-table'>
//               <thead>
//                 <tr>
//                   <th>Sr No</th>
//                   <th>Library Name</th>
//                   <th>Book Name</th>
//                   <th>User Name</th>
//                   <th>Email</th>
//                   <th>Issue Date</th>
//                   <th>Due Date</th>
//                   <th>Return Date</th>
//                   <th>Status</th>
//                   <th>Approval</th>
//                 </tr>


//              <tr>
//                   <th></th>
//                   <th>
//                     <input
//                       type="text"
//                       className="form-control form-control-sm"
//                       placeholder="Filter by Name"
//                       value={filters.student_name}
//                       onChange={(e) => {
//                         setFilters({ ...filters, student_name: e.target.value });
//                         setCurrentPage(1);
//                       }}
//                     />
//                   </th>
//                   <th>
//                     <input
//                       type="text"
//                       className="form-control form-control-sm"
//                       placeholder="Filter by Email"
//                       value={filters.email}
//                       onChange={(e) => {
//                         setFilters({ ...filters, email: e.target.value });
//                         setCurrentPage(1);
//                       }}
//                     />
//                   </th>
//                   <th>
//                     <input
//                       type="text"
//                       className="form-control form-control-sm"
//                       placeholder="Filter by Book"
//                       value={filters.book_name}
//                       onChange={(e) => {
//                         setFilters({ ...filters, book_name: e.target.value });
//                         setCurrentPage(1);
//                       }}
//                     />
//                   </th>
//                   <th></th>
//                   <th></th>
//                   <th></th>
//                   <th>
//                     <select
//                       className="form-select form-select-sm"
//                       value={filters.status}
//                       onChange={(e) => {
//                         setFilters({ ...filters, status: e.target.value });
//                         setCurrentPage(1);
//                       }}
//                     >
//                       <option value="">All</option>
//                       <option value="Issued">Issued</option>
//                       <option value="Pending">Pending</option>
//                       <option value="Returned">Returned</option>
//                       <option value="Rejected">Rejected</option>
//                     </select>
//                   </th>
//                   <th></th>
//                 </tr>

//               </thead>
//               <tbody>
//                 {currentBookCopies.map((book, index) => (
//                   <tr key={index}>
//                     <td>{indexOfFirstEntry + index + 1}</td>
//                     <td>{getLibraryName(book.library_id)}</td>
//                     <td>{book.book_name}</td>
//                     <td>{book.student_name}</td>
//                     <td>{book.email}</td>
//                     <td>{book.issue_date ? new Date(book.issue_date).toLocaleDateString() : ''}</td>
//                     <td>{book.due_date ? new Date(book.due_date).toLocaleDateString() : ''}</td>
//                     <td>{book.return_date ? new Date(book.return_date).toLocaleDateString() : ''}</td>
//                     <td>{getStatusText(book.status)}</td>
//                     {/* <td>
//                       {book.status === 1 ? (
//                         <>
//                           <button
//                             className="btn btn-success btn-sm w-50 action-button "
//                             onClick={() => handleApprove(book.issue_id)}
//                           >
//                             Approve
//                           </button>
//                           <button
//                             className="btn btn-danger btn-sm w-50 action-button"
//                             onClick={() => handleReject(book.issue_id)}
//                           >
//                             Reject
//                           </button>
//                         </>
//                       ) : (
//                         book.status === 0 && (
//                           <button
//                             className="btn btn-primary btn-sm w-50 action-button"
//                             onClick={() => handleReturnBook(book.issue_id)}
//                           >
//                             Return
//                           </button>
//                         )
//                       )}
//                     </td> */}


//                     <td>
//                       {book.status === 1 ? (
//                         <div className="d-flex justify-content-center">
//                           <button
//                             className="btn btn-success btn-sm me-2 action-button"
//                             onClick={() => handleApprove(book.issue_id)}
//                           >
//                             Approve
//                           </button>
//                           <button
//                             className="btn btn-danger btn-sm action-button"
//                             onClick={() => handleReject(book.issue_id)}
//                           >
//                             Reject
//                           </button>
//                         </div>
//                       ) : (
//                         book.status === 0 && (
//                           <div className="d-flex justify-content-center">
//                             <button
//                               className="btn btn-primary btn-sm w-100 text-center px-4 py-2 action-button"
//                               onClick={() => handleReturnBook(book.issue_id)}
//                             >
//                               Return
//                             </button>
//                           </div>
//                         )
//                       )}
//                     </td>

//                   </tr>
//                 ))}
//               </tbody>
//             </table>

//             {/* Pagination Controls */}
//             <div className="pagination-controls">
//               <button
//                 className="pagination-button"
//                 onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
//                 disabled={currentPage === 1}
                
//               >
//                 Previous
//               </button>

//               <span className="pagination-info" style={{ margin: "auto" }}>
//                 Page {currentPage} of {Math.ceil(bookCopies.length / entriesPerPage)}
//               </span>

//               <button
//                 className="pagination-button"
//                 onClick={() => setCurrentPage(prev => Math.min(prev + 1, Math.ceil(bookCopies.length / entriesPerPage)))}
//                 disabled={currentPage === Math.ceil(bookCopies.length / entriesPerPage)}
//               >
//                 Next
//               </button>
//             </div>
//           </>
//         )}
//       </div>

//       {modalOpen && (
//         <div className="modal-overlay">
//           <div className="modal-content">
//             <button className="modal-close-button" onClick={() => setModalOpen(false)}>×</button>
//             <h2>Confirm Approval</h2>
//             <p>Are you sure you want to approve this book issue?</p>
//             <button type="button" onClick={handleConfirmApproval}>
//               Confirm
//             </button>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default IssuedBookList;



import React, { useState, useEffect } from 'react';
import axios from 'axios';
import 'react-calendar/dist/Calendar.css';
import * as Constants from '../../Constant/constant';
import { useAuth } from '../../Constant/Auth';
import { useNavigate, useLocation } from 'react-router-dom';
import './IssuedBookList.css';
import Swal from 'sweetalert2';
import SearchableSelect from '../../shared/SearchableSelect';

const IssuedBookList = () => {
  const [libraries, setLibraries] = useState([]);
  const [issueDate, setIssueDate] = useState('');
  const [returnDate, setReturnDate] = useState('');
  const [bookCopies, setBookCopies] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [books, setBooks] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedIssueId, setSelectedIssueId] = useState(null);
  const [approvedIssues, setApprovedIssues] = useState(new Set());
  const [currentPage, setCurrentPage] = useState(1);
  const [searchText, setSearchText] = useState('');

  const [filters, setFilters] = useState({
    library_name: '',
    student_name: '',
    email: '',
    book_name: '',
    status: ''
  });

  const entriesPerPage = 10;
  const itemsPerPage = 10;

  const location = useLocation();
  const navigate = useNavigate();
  const { user } = useAuth();

  const issueDateParam = location.search.split('issueDate=')[1]?.split('&')[0];
  const returnDateParam = location.search.split('returnDate=')[1]?.split('&')[0];

  useEffect(() => {
    fetchBooks();
    fetchLibraries();
    fetchBookList();
  }, []);

  useEffect(() => {
    if (issueDateParam && returnDateParam) {
      setIssueDate(issueDateParam);
      setReturnDate(returnDateParam);
    }
  }, [issueDateParam, returnDateParam]);

  const fetchLibraries = async () => {
    try {
      const response = await axios.get(Constants.API_PATH + `/add_new_library_data`);
      setLibraries(response.data);
    } catch (error) {
      console.error('Error fetching libraries:', error);
      setError('Failed to fetch libraries.');
    }
  };

  const fetchBooks = async () => {
    setLoading(true);
    setError('');
    try {
      const response = await axios.get(Constants.API_PATH + `/issued-books`);
      setBookCopies(response.data);
    } catch (error) {
      console.error('Error fetching issued books:', error);
      setError('Failed to fetch issued books.');
      setBookCopies([]);
    } finally {
      setLoading(false);
    }
  };

  const fetchBookList = async () => {
    try {
      const response = await axios.get(Constants.API_PATH + `/book_list`);
      setBooks(response.data);
    } catch (error) {
      console.error('Error fetching book list:', error);
    }
  };

  const getBookName = (bookId) => {
    const found = books.find((b) => b.id === bookId);
    return found ? found.book_name : 'Unknown Book';
  };

  const handleApprove = (issueId) => {
    setSelectedIssueId(issueId);
    setModalOpen(true);
  };

  const handleConfirmApproval = async () => {
    try {
      const response = await axios.put(`${Constants.API_PATH}/update-book-status/${selectedIssueId}`, {
        status: 0
      });

      if (response.status === 200) {
        alert('Book issue approved successfully');
        setApprovedIssues(prev => new Set(prev.add(selectedIssueId)));
        setBookCopies(prev =>
          prev.map(book =>
            book.issue_id === selectedIssueId ? { ...book, status: 0 } : book
          )
        );
      } else {
        alert('Failed to approve book issue');
      }
    } catch (error) {
      console.error('Error approving book issue:', error);
      alert('Error approving book issue.');
    } finally {
      setModalOpen(false);
    }
  };

  const handleReject = async (issueId) => {
    const confirmReject = window.confirm("Are you sure you want to reject this book issue?");
    if (!confirmReject) return;

    try {
      const response = await axios.put(`${Constants.API_PATH}/update-book-status/${issueId}`, {
        status: 3
      });

      if (response.status === 200) {
        alert('Book issue rejected successfully');
        setBookCopies(prev =>
          prev.map(book =>
            book.issue_id === issueId ? { ...book, status: 3 } : book
          )
        );
      } else {
        alert('Failed to reject book issue');
      }
    } catch (error) {
      console.error('Error rejecting book issue:', error);
      alert('Error rejecting book issue.');
    }
  };

  // const handleReturnBook = async (issueId) => {
  //   try {
  //     const response = await axios.put(`${Constants.API_PATH}/update-book-status/${issueId}`, {
  //       status: 2
  //     });

  //     if (response.status === 200) {
  //       alert('Book returned successfully');
  //       fetchBooks();
  //       setApprovedIssues(prev => {
  //         const newSet = new Set(prev);
  //         newSet.delete(issueId);
  //         return newSet;
  //       });
  //     } else {
  //       alert('Failed to return book');
  //     }
  //   } catch (error) {
  //     console.error('Error returning book:', error);
  //     alert('Error returning book.');
  //   }
  // };


    const handleFineSubmit = async (issueId) => {
      try {
        const response = await axios.put(
          `${Constants.API_PATH}/update-book-status/${issueId}`,
          { status: 5 }
        );
  
        if (response.status === 200) {
          Swal.fire('Success', 'Fine submitted successfully', 'success');
          setBookCopies((prev) =>
            prev.map((book) =>
              book.issue_id === issueId
                ? { ...book, status: 5 }
                : book
            )
          );
        }
      } catch {
        Swal.fire('Error', 'Failed to submit fine', 'error');
      }
    };
  
    const handleReturnBook = async (issueId) => {
      try {
        const response = await axios.put(
          `${Constants.API_PATH}/update-book-status/${issueId}`,
          { status: 2 }
        );
  
        if (response.status === 200) {
          const updatedBook = response.data; // Backend should return updated book with fine
          Swal.fire('Returned', 'Book returned successfully', 'success');
          setBookCopies((prev) =>
            prev.map((book) =>
              book.issue_id === issueId
                ? {
                    ...book,
                    status: 2,
                    return_date: updatedBook.return_date,
                    fine: updatedBook.fine,
                    late_days: updatedBook.late_days
                  }
                : book
            )
          );
        }
      } catch {
        Swal.fire('Error', 'Failed to return book', 'error');
      }
    };
  const getStatusText = (statusCode) => {
    switch (statusCode) {
      case 0: return 'Issued';
      case 1: return 'Pending';
      case 2: return 'Returned';
      case 3: return 'Rejected';
      case 4: return 'Available';
      case 5: return 'Fine Submitted';

      default: return 'Unknown';
    }
  };

  const getLibraryName = (id) => {
    const lib = libraries.find(library => library.id === id);
    return lib ? lib.library_name : 'Unknown Library';
  };

  const filteredBookCopies = bookCopies.filter((book) => {

    const libraryName = getLibraryName(book.library_id);
    const studentName = book.student_name || '';
    const email = book.email || '';
    const bookName = book.book_name || '';
    const statusText = getStatusText(book.status) || '';

    return (
      libraryName.toLowerCase().includes(searchText.toLowerCase() || '') &&
      studentName.toLowerCase().includes(filters.student_name?.toLowerCase() || '') &&
      email.toLowerCase().includes(filters.email?.toLowerCase() || '') &&
      bookName.toLowerCase().includes(filters.book_name?.toLowerCase() || '') &&
      statusText.toLowerCase().includes(filters.status?.toLowerCase() || '')
    );
  });

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredBookCopies.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filteredBookCopies.length / itemsPerPage);


//   const handleEdit = async (book) => {
// //   if (!book.library_id) {
// //     console.error("❌ Missing library_id in book:", book);
// //     Swal.fire('Error', 'Library ID is missing in the selected book.', 'error');
// //     return;
// //   }

//   const { value: formValues } = await Swal.fire({
//     title: 'Edit Issued Book',
//     html: `
      
//       <label for="swal-due-date">Due Date</label>
//       <input id="swal-due-date" type="date" class="swal2-input" value="${book.due_date?.split('T')[0] || ''}" placeholder="Due Date"/>
//     `,
//     focusConfirm: false,
//     showCancelButton: true,
//     confirmButtonText: 'Update',
//     preConfirm: () => {
//       const dueDate = document.getElementById('swal-due-date').value;
//       if (!dueDate) {
//         Swal.showValidationMessage('Please select a due date');
//         return false;
//       }
//       return { due_date: dueDate };
//     }
//   });

//   if (formValues) {
//     try {
//       const response = await axios.put(
//         `${Constants.API_PATH}/issued-books-admin/${book.issue_id}`,
//         {

//           issue_id: book.issue_id,
//           due_date: formValues.due_date
//         }
//       );

//       if (response.status === 200) {
//         Swal.fire('Success', 'Book due date updated successfully', 'success');

//         setBookCopies(prev =>
//           prev.map(b =>
//             b.issue_id === book.issue_id
//               ? { ...b, due_date: formValues.due_date }
//               : b
//           )
//         );
//       }
//     } catch (error) {
//       console.error('❌ Error updating book:', error);
//       Swal.fire('Error', 'Failed to update book due date', 'error');
//     }
//   }
// };


const handleEdit = async (book) => {
  const { value: formValues } = await Swal.fire({
    title: 'Edit Due Date',
    html: `
      <label for="swal-due-date">Due Date</label>
      <input id="swal-due-date" type="date" class="swal2-input" value="${book.due_date?.split('T')[0] || ''}" />
    `,
    focusConfirm: false,
    showCancelButton: true,
    confirmButtonText: 'Update',
    preConfirm: () => {
      const dueDate = document.getElementById('swal-due-date').value;
      if (!dueDate) {
        Swal.showValidationMessage('Please select a due date');
        return false;
      }
      return { due_date: dueDate };
    }
  });

  if (formValues) {
    try {
     const response= await axios.put(`${Constants.API_PATH}/issued-books-admin`, {

  issue_id: book.issue_id,
  due_date: formValues.due_date
});

      if (response.status === 200) {
        Swal.fire('Success', 'Due date updated and email sent to user & librarian', 'success');

        setBookCopies(prev =>
          prev.map(b =>
            b.issue_id === book.issue_id
              ? { ...b, due_date: formValues.due_date }
              : b
          )
        );
      } else {
        Swal.fire('Error', 'Failed to update due date', 'error');
      }
    } catch (error) {
      console.error('❌ Error updating due date:', error);
      Swal.fire('Error', 'Something went wrong', 'error');
    }
  }
};

  return (
    <div className="parent-issue-book-container containernew">
      <h2>All Issued Books</h2>

      <div className="table-section">
        {loading ? (
          <p>Loading...</p>
        ) : error ? (
          <p style={{ color: 'red' }}>{error}</p>
        ) : bookCopies.length === 0 ? (
          <p>No issued books found.</p>
        ) : (
          <>
            <table className='custom-table'>
              <thead>
                <tr>
                  <th>Sr No</th>
                  <th>Library Name</th>
                  <th>Book Name</th>
                  <th>User Name</th>
                  <th>Email</th>
                  <th>Issue Date</th>
                  <th>Due Date</th>
                  <th>Return Date</th>
                  <th>Book Fine</th>

                  <th>Status</th>
                  <th>Approval</th>
                </tr>

                <tr>
                  <th></th>
                  <th>
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      placeholder="Filter by Library"
                      value={searchText}
                      onChange={(e) => {
                        setSearchText(e.target.value);
                        setCurrentPage(1);
                      }}
                    />
                  </th>

                  <th>
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      placeholder="Filter by Book"
                      value={filters.book_name}
                      onChange={(e) => {
                        setFilters({ ...filters, book_name: e.target.value });
                        setCurrentPage(1);
                      }}
                    />
                  </th>
                  <th>
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      placeholder="Filter by Name"
                      value={filters.student_name}
                      onChange={(e) => {
                        setFilters({ ...filters, student_name: e.target.value });
                        setCurrentPage(1);
                      }}
                    />
                  </th>
                  <th>
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      placeholder="Filter by Email"
                      value={filters.email}
                      onChange={(e) => {
                        setFilters({ ...filters, email: e.target.value });
                        setCurrentPage(1);
                      }}
                    />
                  </th>
                  <th></th>
                  <th></th>
                  <th></th>
                  <th></th>

                  <th>
                    <SearchableSelect
                      value={filters.status}
                      onChange={(e) => {
                        setFilters({ ...filters, status: e.target.value });
                        setCurrentPage(1);
                      }}
                      options={[
                        { value: 'Issued', label: 'Issued' },
                        { value: 'Pending', label: 'Pending' },
                        { value: 'Returned', label: 'Returned' },
                        { value: 'Rejected', label: 'Rejected' },
                        { value: 'Fine Submitted', label: 'Fine Submitted' }
                      ]}
                      placeholder="All"
                    />
                  </th>
                  <th></th>
                </tr>

              </thead>
              <tbody>
                {currentItems.map((book, index) => (
                  <tr key={index}>
                    <td>{indexOfFirstItem + index + 1}</td>
                    <td>{getLibraryName(book.library_id)}</td>
                    <td>{book.book_name}</td>
                    <td>{book.student_name}</td>
                    <td>{book.email}</td>
                    <td>{book.issue_date ? new Date(book.issue_date).toLocaleDateString() : ''}</td>
                    <td>{book.due_date ? new Date(book.due_date).toLocaleDateString() : ''}</td>
                    <td>{book.return_date ? new Date(book.return_date).toLocaleDateString() : ''}</td>
                    <td>₹{book.fine}</td>
                    <td>{getStatusText(book.status)}</td>
                    {/* <td>
                      {book.status === 1 ? (
                        <div className="d-flex justify-content-center">
                          <button
                            className="btn btn-success btn-sm me-2 action-button"
                            onClick={() => handleApprove(book.issue_id)}
                          >
                            Approve
                          </button>
                          <button
                            className="btn btn-danger btn-sm action-button"
                            onClick={() => handleReject(book.issue_id)}
                          >
                            Reject
                          </button>
                        </div>
                      ) : (

                        book.status === 0 && (
                          <div className="d-flex justify-content-center">
                            <button
                              className="btn btn-primary btn-sm w-100 text-center px-4 py-2 action-button"
                              onClick={() => handleReturnBook(book.issue_id)}
                            >
                              Return
                            </button>
                          </div>
                        )
                      )}
                    </td> */}

                    <td>


  {book.status === 1 ? (
                        <div className="d-flex justify-content-center">
                          <button className="btn btn-success btn-sm me-2" onClick={() => handleApprove(book.issue_id)}>Approve</button>
                          <button className="btn btn-danger btn-sm" onClick={() => handleReject(book.issue_id)}>Reject</button>
                        </div>
                      ) : book.status === 0 ? (
                        <div className="d-flex justify-content-center gap-2">
                          <button className="btn btn-primary btn-sm" onClick={() => handleReturnBook(book.issue_id)}>Return</button>
                          <div className=' w-100 mw-100 text-nowrap'>
                          <button className="btn btn-warning px-2 py-2" onClick={() => handleEdit(book)}>Renew Due Date</button>
                           </div>
                        </div>
                      ) : book.status === 2 && Number(book.fine) > 0 ? (
                        <button className="btn btn-info btn-sm w-100" onClick={() => handleFineSubmit(book.issue_id)}>Submit Fine</button>
                      ) : book.status === 5 ? (
                        <button className="btn btn-success btn-sm w-100" disabled>Fine Submitted</button>
                      ) : null}
</td>
                  </tr>
                ))}
              </tbody>
            </table>

            <div className="pagination-controls">
              <button
                className="pagination-button"
                onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                disabled={currentPage === 1}
              >
                Previous
              </button>

              <span className="pagination-info" style={{ margin: "auto" }}>
                Page {currentPage} of {totalPages}
              </span>

              <button
                className="pagination-button"
                onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                disabled={currentPage === totalPages}
              >
                Next
              </button>
            </div>
          </>
        )}
      </div>

      {modalOpen && (
        <div className="modal-overlay">
          <div className="modal-content">
            <button className="modal-close-button" onClick={() => setModalOpen(false)}>×</button>
            <h2>Confirm Approval</h2>
            <p>Are you sure you want to approve this book issue?</p>
            <button type="button" onClick={handleConfirmApproval}>
              Confirm
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default IssuedBookList;

